<app-breadcrumbs></app-breadcrumbs>
<app-search-form [searchedComponent]="'medicalTests'"></app-search-form>
<app-all-medical-tests></app-all-medical-tests>

